<template>
    <div id="mPane3" class="mPane3-back-up">
        <div slot="page-top" class="page-top">
            <slot name="page-top"></slot>
        </div>
        <m-search-list :popPrefix="popPrefix" ref="searchList" :searchId="searchId" @search-list-change="searchListChange"
            :list="config.searchList" :searchTotalTitle="searchTotalTitle" :initSearchInfo="initSearchInfo" :btnColSpan="btnColSpan"
            :configurationUrl="configurationUrl" :longPrefix="longPrefix" :advancePrefix="advancePrefix" :searchSetTitle="searchSetTitle" :moduleCode="moduleCode"
            :pickerConfig="pickerConfig" @resetAdvanceParams="resetAdvanceParams"
            @onSearchChange="searchChange" @tableAdvance="tableAdvance" @handleFussyChange="handleFussyChange"
            @clear="clear">
            <span slot="search-list-advance-right">
              <slot name="search-list-advance-right"></slot>
            </span>
            <span slot="search-list-advance-last">
              <slot name="search-list-advance-last"></slot>
            </span>
          <div slot="table-module-btn" class="btn-box">
            <slot name="table-module-btn"></slot>
            <el-tooltip v-if="config.configuration?false: true" class="item allocation-box" effect="dark" :content="$translate('component.E202007310002', { defaultText: '列配置' })" placement="bottom">
              <el-button size="mini" class="el-icon-setting" @click="getTitleList"></el-button>
            </el-tooltip>
            <el-dialog :visible.sync="showModal"
                :close-on-click-modal="config.configurationCloseOnClickModal || false"
                :close-on-press-escape="config.configurationCloseOnPressEscape || false"
                :title="$translate('component.E202007310002', { defaultText: '列配置' })" @close="dialogClose">
                <configuration :checkedList="checkedList" :selectAllColumns="config.table.columns" ref="dialog"
                             @getTableConfigList="getTableConfigList" @tableConfigClose="tableConfigClose" :columnNum='columnNum'></configuration>
            </el-dialog>
          </div>
            <template v-slot:search-append>
                <slot name="search-append"></slot>
            </template>
        </m-search-list>
        <div slot="table-top">
             <slot name="table-top"></slot>
        </div>
        <m-table
          ref="table"
          :popPrefix="popPrefix"
          :longPrefix="longPrefix"
          :verification="verification"
          :tableConfig="config.table"
          :tableHeight="tableHeight"
          :tableData=totalData
          :tableList="tableList"
          :loading="loading"
          :columnsWidthConfig="columnsWidthConfig"
          @select="select"
          @tab-advanced-search="tabAdvancedSearch"
          @row-db-click="rowDBClick"
          @row-click="rowClick"
          @save-data="saveData"
          @btnEvent="btnEvent"
          @onSelectionChange="selectChange"
          @element-change="elementChange"
          @column-filter-search="columnFilterSearch"
          @moreAction="moreAction"
          @btnClick="btnClick"
          @onCellDblclick="onCellDblclick"
          @btnRightClick="btnRightClick"
          @header-dragend="headerDragendHandler"
          @sortChange="sortChange" >
            <template v-slot:customTableCell="scope">
                <slot name="customTableCell" v-bind="scope"></slot>
            </template>
            <template v-slot:editSlot="scope">
                <slot name="editSlot" v-bind="scope"></slot>
            </template>
            <div slot="expand-table-content" slot-scope="{expandProps}"><slot name="expand-table-cont" :expandTable="expandProps"></slot></div>
        </m-table>
        <div slot="table-bottom" class="table-bottom">
             <slot name="table-bottom"></slot>
        </div>
        <el-row type="flex" class="row-bg" justify="space-between">
            <span class="page-text">
                <div v-if="config.table.selectBtn">
                    {{$translate('component.E1202104120938', { defaultText: '已选' })}}
                    <span class="text-color">{{checkedNum}}</span>
                    {{$translate('component.E1202104120939', { defaultText: '项' })}}
                </div>
                <slot name="page-module-btn"></slot>
            </span>
            <span><m-page ref="page" :current-page="currentPage" :pageData="config.page" :total="pageTotal" @on-page-change="pageChange" @on-size-change="sizeChange"></m-page></span>
        </el-row>
    </div>
</template>
<script>
import mSearchList from './mSearchList';
import mTable from './mTable';
import mPage from './mPage';
import configuration from './configuration-list';
import { getList } from './api';
import { mapGetters } from 'vuex';
import { getLocal, setLocal } from '@/utils/storage';
import { I18nMixins } from '@/components/utils/i18n';

export default {
    name: 'mPanel',
    mixins: [I18nMixins],
    components: { mTable, mSearchList, mPage, configuration },
    computed: {
        ...mapGetters(['menus', 'user']),
        pageUnionKey() {
            // 页面宽度key规则： columnsWidthConfig-[resourceCode]，这里不区分租户，不同租户的表格列宽度应还是一致的
            return ['columnsWidthConfig', this.resourceCode].join('-');
        }
    },
    data() {
        return {
            tableHeight: 0, // 表格高度
            checkedNum: 0,
            showModal: false,
            tableList: '',
            settingColumns: this.config.table.columns,
            checkedList: '',
            pageState: true,
            popPrefix: this.config.popPrefix ? this.config.popPrefix : '/api-mdm/dictionaryDetail/dict',
            advancePrefix: this.config.advancePrefix ? this.config.advancePrefix : '/api-mdm',
            longPrefix: this.config.longPrefix ? this.config.longPrefix : '/api-gwms/es/comboBox',
            configurationUrl: this.config.configurationUrl ? this.config.configurationUrl : '/api-auth',
            resourceCode: '',
            searchId: 'searchListConfig',
            pageID: 'columnsConfig',
            columnsWidthConfig: null
        };
    },
    props: {
        config: Object,
        totalData: Array,
        pageTotal: Number,
        dataSourceUrl: String,
        // pageID: String,
        // searchId: String,
        currentPage: Number,
        moduleCode: [Number, String], // 子页面标识，主要用于区分列配置与高级查询自定义条件
        configureDefaultHeight: [Number, String],
        extraFixedHeight: { type: Number, default: () => 0 },
        loading: {
            type: Boolean,
            default() {
                return true;
            }
        },
        verification: {
            type: Object,
            default() {
                return {};
            }
        },
        method: {
            type: String,
            default: 'get'
        },
        searchTotalTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        searchSetTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        columnNum: Number,
        btnColSpan: {
            type: Number,
            default() {
                return 0;
            }
        },
        initSearchInfo: {
            type: Object,
            default() {
                return {};
            }
        },
        pickerConfig: {
            type: [Object, String],
            default() {
                return '';
            }
        }
    },
    methods: {
        resetAdvanceParams(item) {
            this.$emit('resetAdvanceParams', item);
        },
        select(selection, rows) {
            this.$emit('row-select', selection, rows);
        },
        sortChange(props) {
            this.$emit('sortChange', props);
        },
        handleFussyChange(config, val, key) {
            this.$emit('handleFussyChange', config, val, key);
        },
        searchListChange(config, data) {
            this.$emit('search-list-change', config, data);
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        if (childrens[i].frontUrl === this.$route.path) {
                            this.resourceCode = childrens[i].resourceCode;
                        } else {
                            this.deepMenu(childrens[i]);
                        }
                    }
                }
            }
        },
        btnEvent(event, data) {
            if (event === 'view') {
                this.$emit('check-btn', data);
            } else if (event === 'delete') {
                this.$emit('del-btn', data);
            } else {
                this.$emit(`${event}-btn`, data);
            }
        },
        photosTable(data) {
            this.$emit('photos-btn', data);
        },
        detailTable(data) {
            this.$emit('detail-btn', data);
        },
        uploadTable(data) {
            this.$emit('upload-btn', data);
        },
        // 表格中按钮触发事件
        checkTable(data) {
            this.$emit('check-btn', data);
        },
        editTable(data) {
            this.$emit('edit-btn', data);
        },
        separateTable(data) {
            this.$emit('separate-btn', data);
        },
        printTable(data) {
            this.$emit('print-btn', data);
        },
        delTable(data) {
            this.$emit('del-btn', data);
        },
        editorTable(data) {
            this.$emit('editor-btn', data);
        },
        removeTable(data) {
            this.$emit('remove-btn', data);
        },
        dispatchTable(data) {
            this.$emit('dispatch-btn', data);
        },
        saveData(data) {
            this.$emit('saveData', data);
        },
        // 表单选项变化
        selectChange(data) {
            this.$emit('selectChange', data);
            this.checkedNum = data.length;
        },
        elementChange(data) {
            this.$emit('element-change', data);
        },
        rowDBClick(row) {
            this.$emit('row-db-click', row);
        },
        rowClick(row) {
            this.$emit('row-click', row);
        },
        onCellDblclick (row, column, cell, event) {
            this.$emit('onCellDblclick', row, column, cell, event);
        },
        // 搜索内容变化
        searchChange(data) {
            this.$refs.page.pageState = false;
            this.$emit('searchChange', data);
            this.$nextTick(() => {
                this.$refs.page.pageState = true;
            });
        },
        // 分页器改变触发事件
        pageChange(page) {
            this.$emit('pageChange', page);
        },
        sizeChange(size) {
            this.config.page.pageSize = size;
            this.$emit('sizeChange', size);
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            if (this.config.configuration) {
            } else {
                this.showModal = false;
                // id属性为本地缓存使用，非接口属性
                const pramas = {
                    'configName': tabelConfigName,
                    'configNameCn': tabelConfigList,
                    'subjectType': this.pageID,
                    'moduleCode': this.moduleCode || this.resourceCode,
                    'id': this.user.employeeId
                };
                getList.post(this.configurationUrl, pramas).then(() => {});
                this.tableList = tabelConfigList;
                this.$emit('tableConfigChange', tabelConfigList);
            }
        },
        tableConfigClose() {
            this.showModal = false;
        },
        dialogClose() {
            this.$refs.dialog.initData();
        },
        // 获取表格头保存参数
        async getTableTitle() {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            await this.deepMenu(menu);
            if (this.config.configuration) {
                return new Promise((resolve) => {
                    resolve(() => {
                        this.checkedList = '';
                    });
                });
            } else {
                let allColumns = [];
                let allColumnsprop = [];
                this.config.table.columns.map((item, index) => {
                    if (this.columnNum && index >= this.columnNum) {
                    } else {
                        allColumns.push(item.label);
                        allColumnsprop.push(item.prop);
                    }
                });
                allColumns = allColumns.join(',');
                allColumnsprop = allColumnsprop.join(',');
                // id属性为本地缓存使用，非接口属性
                const pramas = {
                    'configName': allColumnsprop,
                    'configNameCn': allColumns,
                    'moduleCode': this.moduleCode || this.resourceCode,
                    'subjectType': this.pageID,
                    'id': this.user.employeeId
                };
                return getList.get(this.configurationUrl, pramas).then(data => {
                    if (data.data && data.data.configNameCn) {
                        this.checkedList = data.data.configNameCn;
                    } else {
                        this.checkedList = this.config.table.initTableLabels ? this.config.table.initTableLabels : allColumns;
                    }
                }).catch(() => {
                    this.checkedList = this.config.table.initTableLabels ? this.config.table.initTableLabels : allColumns;
                });
            }
        },
        initTitleList() {
            let laberString = [];
            if (this.checkedList === '') {
                this.config.table.columns.map(data => {
                    laberString.push(data.label);
                });
                laberString = laberString.join(',');
                this.tableList = laberString;
            } else {
                this.tableList = this.checkedList;
            }
        },
        getTitleList() {
            return this.getTableTitle().then(() => {
                this.showModal = true;
            });
        },
        // 表格内高级搜索
        tabAdvancedSearch(data, item, type, searchData) {
            this.$refs.searchList.detaliSearch(data, item, type, searchData);
        },
        tableAdvance(prop, advanceCode, data, code) {
            this.$refs.table.ruleForm[prop] = data;
            this.$refs.table.ruleForm[advanceCode] = code;
        },
        columnFilterSearch(data) {
            this.$refs.searchList.onSearchChange(data);
        },
        statusChange(status) {
            this.$refs.table.changeStatu(status);
        },
        changeLoading(status) {
            this.$refs.searchList.changeLoading(status);
        },
        moreAction(selection, index) {
            this.$emit('moreAction', selection, index);
        },
        trajectoryTable(data) {
            this.$emit('trajectory-btn', data);
        },
        btnClick(val, index, row, columnsName, item) {
            this.$emit('btnClick', val, index, row, columnsName, item);
        },
        btnRightClick(val, index, row, columnsName) {
            this.$emit('btnRightClick', val, index, row, columnsName);
        },
        headerDragendHandler({ width, property }) {
            this.columnsWidthConfig = this.columnsWidthConfig || {};
            this.columnsWidthConfig[property] = width;
            setLocal(this.pageUnionKey, this.columnsWidthConfig);
        },
        clear() {
            this.$emit('clear');
        },
        updateTableHeight() {
            // 计算表格的高度
            const serachBox = document.querySelector('.model-table-search');
            const tableBottom = document.querySelector('.table-bottom');
            const pageTop = document.querySelector('.page-top');
            let searchBoxHeight = 0;
            let tableBottomHeight = 0;
            let pageTopHeight = 0;
            if (serachBox) {
                searchBoxHeight = serachBox.getBoundingClientRect().height;
            }
            if (tableBottom) {
                tableBottomHeight = tableBottom.getBoundingClientRect().height;
            }
            if (pageTop) {
                pageTopHeight = pageTop.getBoundingClientRect().height;
            }
            const tableHeight = window.innerHeight - searchBoxHeight - tableBottomHeight - pageTopHeight - (this.extraFixedHeight || 0) - 110; // 减掉一个固定高度
            // console.log('searchBoxHeight', searchBoxHeight, 'tableHeight', tableHeight);
            this.tableHeight = this.configureDefaultHeight || tableHeight;
        }
    },
    mounted() {
        this.getTableTitle().then(() => {
            this.initTitleList();
        });
        // 获取表格列宽度配置对象
        this.columnsWidthConfig = getLocal(this.pageUnionKey);

        this._updateTableHeight = this.updateTableHeight.bind(this);
        window.addEventListener('resize', this._updateTableHeight);
        this.updateTableHeight();
    },
    activated() {
        window.removeEventListener('resize', this._updateTableHeight);
        window.addEventListener('resize', this._updateTableHeight);
        this.updateTableHeight();
    },
    deactivated () {
        window.removeEventListener('resize', this._updateTableHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this._updateTableHeight);
    }
};
</script>
<style lang="less">
#mPane3 {
    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .margin-bottom-10 {
        margin-bottom: 10px;
    }
    .m-table-wrapper {
        border: 0;
    }

    .m-table:after {
        width: 0;
    }

    .m-table:before {
        height: 0;
    }

    .m-table td,
    .m-table th {
        border-bottom: 0;
    }

    .zk-table {
        border: 0;
    }

    .zk-table__body,
    .zk-table__footer,
    .zk-table__header {
        border-collapse: initial;
    }
    .page-text{
      display: flex;
      white-space: nowrap;
      >div{
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        margin-right: 10px;
        .text-color{
            color: #00BCBF;
            display: inline-block;
            width: 30px;
            text-align: center;
        }
      }
    }

    .btn-box{
      display: flex;
      justify-content: flex-end;
    }
    .row-bg{
      margin-top: 10px;
    }
    .allocation-box{
       margin-left: 10px;
    }
}
.mPane3-back-up {
    .el-table {
        min-height: unset!important;;
        max-height: unset!important;
    }
}
</style>
